import React from "react";
import moment from "moment";
import StyledDataGrid from "styles/styledDataGrid";

const columns = [
  {
    field: "versionText",
    headerName: "Version",
    flex: 0.9,
    headerAlign: "center",
  },
  {
    field: "policyChangeDate",
    headerName: "Date",
    minWidth: 100,
    valueGetter: (params) => {
      return moment(params, "MM/DD/YYYY");
    },
    valueFormatter: (params) => {
      return params.format("MM/DD/YYYY");
    },

    sortComparator: (v1, v2) => v1.diff(v2),
    headerAlign: "center",
  },
  {
    field: "author",
    headerName: "Author",
    flex: 1,
    headerAlign: "center",
  },
  {
    field: "description",
    headerName: "Details",
    flex: 4,

    headerAlign: "center",
    renderCell: (params) => {
      const screenWidth = window.innerWidth;
      const singleLineThreshold = screenWidth > 1280 ? 100 : 80;
      const isSingleLine =
        params.value && params.value.length < singleLineThreshold;
      return (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.5",
            overflow: "visible",
            display: "block",
            marginTop: isSingleLine ? "8px" : "0px",
          }}
        >
          {params.value}
        </div>
      );
    },
  },
];

const PolicyHistoryGrid = ({ rows }) => {
  const getRowHeight = (params) => {
    const baseHeight = 40;
    const description = params.model.description || "";
    const lineHeight = 1.5 * 14;
    const lineCount = Math.ceil(description.length / 90);
    return Math.max(baseHeight, lineCount * lineHeight);
  };
  return (
    <StyledDataGrid
      rows={rows}
      columns={columns}
      disableColumnSelector
      disableColumnMenu
      getRowHeight={getRowHeight}
      initialState={{
        sorting: {
          sortModel: [{ field: "policyChangeDate", sort: "desc" }],
        },
      }}
    />
  );
};

export default PolicyHistoryGrid;
